import { PrimaryButton, SecondaryButton } from '@/lib';
import type { InboxItem } from '@/mocks/fixtures';
import {
  DEFAULT_S10_FILTERS,
  saveS10Filters,
  type S10Filters,
} from './filters-state';

const KINDS: InboxItem['kind'][] = ['alert', 'mention', 'subscription'];

export function FiltersTab({
  filters,
  onChange,
}: {
  filters: S10Filters;
  onChange: (next: S10Filters) => void;
}) {
  const update = (next: S10Filters) => {
    saveS10Filters(next);
    onChange(next);
  };

  const toggleKind = (k: InboxItem['kind']) => {
    const present = filters.kinds.includes(k);
    update({
      ...filters,
      kinds: present
        ? filters.kinds.filter((x) => x !== k)
        : [...filters.kinds, k],
    });
  };

  return (
    <section className="flex max-w-2xl flex-col gap-sp-4">
      <label className="flex items-center gap-sp-2 text-fs-body text-gray-900">
        <input
          type="checkbox"
          checked={filters.unreadOnly}
          onChange={(e) => update({ ...filters, unreadOnly: e.target.checked })}
        />
        Show unread only
      </label>

      <fieldset className="flex flex-col gap-sp-2">
        <legend className="text-fs-eyebrow font-medium uppercase tracking-[0.14em] text-gray-700">
          Kinds
        </legend>
        {KINDS.map((k) => (
          <label
            key={k}
            className="flex items-center gap-sp-2 text-fs-body text-gray-900"
          >
            <input
              type="checkbox"
              checked={filters.kinds.includes(k)}
              onChange={() => toggleKind(k)}
            />
            {k}
          </label>
        ))}
        <p className="text-fs-meta text-gray-700">
          Empty selection means "show all kinds".
        </p>
      </fieldset>

      <div className="flex items-center gap-sp-3">
        <PrimaryButton label="Apply" onClick={() => update(filters)} />
        <SecondaryButton
          label="Reset"
          onClick={() => update(DEFAULT_S10_FILTERS)}
        />
      </div>
    </section>
  );
}
